import { SourcingChannelDetails } from 'api-clients/monolith';
import { useIntl } from 'react-intl';

import { Budget } from '@/components/pages/edit-campaign/form-elements/budget';
import { Dates } from '@/components/pages/edit-campaign/form-elements/dates';
import { EndDateSyncBanner } from '@/components/pages/edit-campaign/reach/end-date-sync-banner';
import { TargetBudget } from '@/components/pages/edit-campaign/target-budget';
import { ChannelIcon } from '@/components/ui/channel-icon';
import { Skeleton } from '@/components/ui/skeleton';
import { Typography } from '@/components/ui/typography';
import { useEditCampaignContext } from '@/contexts/edit-campaign-context';

export function PublisherForm() {
  const intl = useIntl();
  const { selectedPublisher, isFetching } = useEditCampaignContext();

  return (
    <div className="border-fx-neutral-200 mb-4 flex w-[720px] flex-col gap-6 rounded-xl border bg-white px-12 py-6 shadow-sm">
      <ChannelIconWrapper
        isFetching={isFetching}
        channel={selectedPublisher?.sourcing_channel}
      />

      <Dates />

      <EndDateSyncBanner />

      <Budget
        label={intl.formatMessage({
          defaultMessage: 'Budget per day',
          description: 'Label for input to enter the budget per day',
        })}
      />

      <TargetBudget />
    </div>
  );
}

function ChannelIconWrapper({
  isFetching,
  channel,
}: {
  isFetching: boolean;
  channel?: SourcingChannelDetails;
}) {
  if (isFetching) return <ChannelIconSkeleton />;

  if (channel)
    return (
      <div className="mx-auto mb-6 flex items-center gap-3">
        <ChannelIcon channelSlug={channel.slug} variant="small" size="lg" />
        <Typography variant="h3">{channel.name}</Typography>
      </div>
    );

  return <span className="h-14" />;
}

function ChannelIconSkeleton() {
  return (
    <div className="mx-auto mb-6 flex items-center gap-3">
      <Skeleton className="h-8 w-8" />
      <Skeleton className="h-8 w-30" />
    </div>
  );
}
